import c from 'classnames';
import { Link } from 'gatsby';
import React, { useState } from 'react';
import './Navigation.css';
import SubNavigationItem from './SubNavigationItem';

const Navigation = () => {
    const [open, setOpen] = useState(false);

    const toggleOpen = () => {
        setOpen(!open);
    };

    return (
        <nav className="Navigation">
            <button
                className={c('NavigationToggle bare-btn', { open })}
                onClick={toggleOpen}
                aria-expanded={open}
                aria-controls="navigation"
            >
                <span className="Hamburger" />
                <span className="sr-only">Navigation</span>
            </button>
            <ol id="navigation" className={c('NavigationList')} hidden={!open}>
                <SubNavigationItem label="Features">
                    <li>
                        <Link to="/mapping" title="To Mapping" className="SubNavigationItem">
                            Mapping
                        </Link>
                    </li>
                    <li>
                        <Link to="/field-jobs" title="To Plan work" className="SubNavigationItem">
                            Plan work
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/livestock-management"
                            title="To Livestock management"
                            className="SubNavigationItem"
                        >
                            Livestock
                        </Link>
                    </li>
                    <li>
                        <Link to="/reporting" title="To Reporting" className="SubNavigationItem">
                            Reporting
                        </Link>
                    </li>
                    <li>
                        <Link to="/scouting" title="To Scouting" className="SubNavigationItem">
                            Scouting
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/field-health"
                            title="To Field Health"
                            className="SubNavigationItem"
                        >
                            Field Health
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/pesticide-check"
                            title="To Pesticide check"
                            className="SubNavigationItem"
                        >
                            Pesticide check
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/integrations"
                            title="To Integrations"
                            className="SubNavigationItem"
                        >
                            Integrations
                        </Link>
                    </li>
                </SubNavigationItem>
                <li>
                    <Link to="/pricing" title="To Pricing" className="NavigationItem">
                        Pricing
                    </Link>
                </li>
                <li>
                    <a
                        href="https://blog.fieldmargin.com"
                        title="Fieldmargin blog"
                        className="NavigationItem"
                    >
                        Blog
                    </a>
                </li>
                <li>
                    <Link to="/about-us" title="To About us" className="NavigationItem">
                        About Us
                    </Link>
                </li>
                <li>
                    <a
                        href="http://support.fieldmargin.com"
                        title="Fieldmargin support"
                        className="NavigationItem"
                    >
                        Support
                    </a>
                </li>
            </ol>
        </nav>
    );
};

export default Navigation;
